import React from "react";
import { Modal } from "react-bootstrap";

const ReusableModal = ({ show, onClose, title, body, footer,  modalsize ,modalContentClass , showCloseButton = true,  }) => {
  
  
  return (
    <Modal show={show} onHide={onClose} centered id="verticalycentered" dialogClassName={`modal-${modalsize}`} contentClassName={modalContentClass}    >
      <Modal.Header closeButton={showCloseButton} >
        <Modal.Title>
        
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {body}
        </Modal.Body>
      <Modal.Footer>
        {footer || null}
      </Modal.Footer>
    </Modal>
  );
};

export default ReusableModal;
